const tech_img = require('../../assets/img/tutorials/bailen/tech.png');
const secondary_tech_img = require('../../assets/img/tutorials/bailen/secondary-tech.png');
const func_img = require('../../assets/img/tutorials/bailen/func.png');
const secondary_func_img = require('../../assets/img/tutorials/bailen/secondary-func.png');

export const BailenSteps = [
    {
        name: 'Puente de Bailén',
        title: 'Descripción funcional',
        description: <span>
            <p>El gemelo digital del <b>Puente de Bailén en Madrid</b>, generado a partir de una <b>nube de puntos</b> (<i>point cloud</i>) <b>ofrece una representación tridimensional detallada de la infraestructura</b>. 
            </p>
            <p>Este modelo virtual, además de la propia información de arquitectura y modelado 3D, incorpora datos continuos sobre las condiciones meteorológicas y el tránsito de vehículos, recabados mediante sensores y sistemas de monitorización en tiempo real.
            </p>
            <p>A través de este gemelo, se dispone de una <b>plataforma de análisis de la evolución de la infraestructura y de simulación para evaluar el impacto de la carga vehicular y los factores ambientales en la integridad estructural del puente</b>.
</p>
        </span>,
        secondarydescription: <span>
            <p>Área de Gobierno de Cultura, Turismo y Deporte</p>
            <p>Área de Gobierno de Urbanismo, Medio Ambiente y Movilidad</p>
            <p>Área de Gobierno de Vicealcaldía, Portavoz, Seguridad  y Emergencias</p>
        </span>,
        mainimage: <img src={func_img} alt="main_func" />,
        secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
    },
    {
        name: 'Puente de Bailén',
        title: 'Descripción técnica',
        description: <div>
            <span>
                Integraciones técnicas
                <ul>
                    <li><b>Renderizado Inmersivo</b> que ofrece visualizaciones realistas y en tiempo real, mejorando la experiencia de usuario y la comprensión del espacio físico.</li>
                    <li>Uso de <b>modelos Predictivos</b> que analizan grandes volúmenes de datos para anticipar tendencias y patrones, optimizando la toma de decisiones.</li>
                    <li><b>Integración de Dispositivos IoT</b> para la recopilación continua de datos del entorno, que soportan la infraestructura de la ciudad inteligente y la conectividad.</li>
                </ul>
            </span>
            <span>
                Origen de Datos
                <ul>
                <li>Información de <b>nube de puntos</b> de la infraestructura, para un modelado 3D realista e integral.</li>
                    <li>Información en <b>tiempo real</b> sobre el estado del tráfico, que permite ajustar los flujos de movilidad y mejorar la gestión de la vía pública.</li>
                    <li>Utilización de <b>datos meteorológicos de la Agencia Estatal de Meteorología</b> para mejorar predicciones climáticas y su impacto en la vida urbana.</li>
                </ul>
            </span>


        </div>,
        mainimage: <img src={tech_img} alt="main_tech" />,
        secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
    }
];